import { Injectable } from '@angular/core';
import { HttpLogado } from '../HttpLogado';
import { environment } from '../../environments/environment';
import convertHttpErrorToLocal from 'src/utils/convertHttpErrorToLocal';
import { Plan } from 'src/classes/plan';

function convertBackendPlanToFrontend(obj: any): Plan {
  if (!obj.id) {
    throw new Error("Invalid plan structure from server");
  }
  return Object.assign(new Plan(), {
    "id": obj.id as number,
    "name": obj.name as string,
    "deliveries": obj.deliveries as number,
    "priceBRL": obj.priceBRL as number,
    'priceUSD': obj.priceUSD as number,
    show:obj.show as boolean
  });
}

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  constructor(
    private http: HttpLogado
  ) { }

  async getPlan(index: number): Promise<Plan> {
    try {
      const response: any = await this.http.get(`${environment.baseUrl}/plans/get/${index}`).toPromise();
      return convertBackendPlanToFrontend(response);
    } catch (err) {
      convertHttpErrorToLocal(err);
    }
  }

  async listPlans(): Promise<Plan[]> {
    try {
      const response: any = await this.http.get(`${environment.baseUrl}/plans/list`).toPromise();
      return response.map(convertBackendPlanToFrontend);
    } catch (err) {
      convertHttpErrorToLocal(err);
    }
  }
}
